import {
  CardSkeletonContainer,
  CardHeaderSkeleton,
  DateSkeleton,
  StatusSkeleton,
  TitleSkeleton,
  SubtitleSkeleton,
  UserSkeleton,
} from "./LeftListSkeleton.styles";
import { Container } from "./styles";

const CardSkeleton: React.FC = () => (
  <CardSkeletonContainer>
    <CardHeaderSkeleton>
      <DateSkeleton />
      <StatusSkeleton />
    </CardHeaderSkeleton>
    <TitleSkeleton />
    <SubtitleSkeleton />
    <UserSkeleton />
  </CardSkeletonContainer>
);

export const LeftListSkeleton: React.FC<{ cardCount?: number }> = ({
  cardCount = 5,
}) => {
  return (
    <Container>
      {Array.from({ length: cardCount }).map((_, index) => (
        <CardSkeleton key={index} />
      ))}
    </Container>
  );
};
